export default {
  namespaced: true,
  alarm: {
    alarm_id: "Alarme ID",
    description: "Descrição",
    title: "Alarme | Alarmes",
    folioCAD: "Folha CAD",
    statusCAD: "Status CAD",
    reaction_patrol: "Patrulha de reação",
    alarm_type: "Tipo de alarme",
    status: "Status",
    attending: "Em atenção",
    attended: "Atendidos",
    waiting: "Em Espera",
    canceled: "Canceladas",
    all: "Todos",
    start_date_filter: "Data de início",
    end_date_filter: "Data final",
    date_filter: "Filtro de Data",
    dateRange: "Intervalo de dias",
    dateRangeNone: "Nenhum",
    dateRangeLast30: "Últimos 30 dias",
    dateRangeLast60: "Últimos 60 dias",
    dateRangeHint: "Calculado a partir do momento em que a vista do alarme é aberta",
    new_alarms: " novos alarmes",
    alarms: "Alarmes",
    dispatch: "Disparar",
    dispatchAlarm: "Disparar alarme",
    alarmCreated: "Alarme disparado com sucesso",
    alarmError: "Não foi possível disparar o alarme",
    noImagesInCarrousel: "Não há imagens disponíveis",
    loadingImage: "Carregando imagem...",
    imageNotAvailable: "Imagem não disponível",
    comment: "Comentário | Comentários",
    type_alarm_not_found: "Nenhum tipo de alarme encontrado",
    created_by: "criado por",
    timeline: {
      title: "Timeline",
      no_items: "Não há itens de timeline disponíveis.",
      analytic_record: "Registro Analítico",
      comment: "Comentário",
      detection_event: "Evento de Detecção",
      command_log: "Log de Comando",
      action_plans_logs: "Registros de Planos de Ação",
      alarm_bridge_device_logs: "Eventos do Painel",
      users: "Usuários",
      unknown_command: "Comando Desconhecido",
      camera: "Câmera",
      server: "Servidor",
      category: "Categoria",
      alarm_type: "Tipo de Alarme",
      priority: "Prioridade",
      matched_rules: "Regras Correspondentes",
      record_info: "Registro: {to} de {total} eventos similares",
      event_info: "Evento: {to} de {total} detecções similares",
      age: "Idade",
      glasses: "Óculos",
      yes: "Sim",
      no: "Não",
      list: "Lista",
      emotion: "Emoção",
      score: "Pontuação",
      type: "Tipo",
      provider: "Provedor",
      detection: "Detecção",
      action: "Ação",
      target: "Alvo",
      executed_by: "Executado por",
      executed_by_system: "Executado pelo Sistema",
      user: "Usuário",
      command_type: "Tipo de Comando",
      command: "Comando",
      command_label: "Rótulo do Comando",
      command_data: "Dados do Comando",
      ai_prompt: "Prompt da IA",
      ai_decision: "Decisão da IA",
      image: "Imagem",
      alarm_level: "Nível do Alarme",
      user_id: "ID do Usuário",
      delay_time: "Tempo de Atraso",
      dispatcher_info: "Informações do Dispatcher",
      dispatcher_id: "ID do Dispatcher",
      source: "Fonte",
      workflow_id: "ID do Workflow",
      camera_round: "Ronda de Câmeras",
      name: "Nome",
      cameras: "Câmeras",
      users: "Usuários",
      location: "Localização",
      loop: "Loop",
      radius: "Raio",
      layout: "Layout",
      dispatcher_name: "Nome do Dispatcher",
      alarm_id: "ID do Alarme",
      description: "Descrição",
      action_plan: "Plano de Ação",
      action_plans_logs: "Registros de Planos de Ação",
      instance: "Instância",
      plan_id: "ID do Plano",
      duration: "Duração",
      step: "Passo",
      steps: "Passos",
      decision: "Decisão",
      node: "Nó",
      terminate: "Terminado",
      partial_terminate: "Parcialmente Terminado",
      question: "Pergunta",
      answer: "Resposta",
      answer_options: "Opções de Resposta",
      required: "Obrigatório",
      executed: "Executado",
      continue: "Continuar",
      outputs: "Saídas",
      data_types: "Tipos de Dados",
      filled_stack: "Stack Preenchido",
      reason: "Razão",
      started_at: "Iniciado em",
      ended_at: "Finalizado em",
      command_data: "Dados do Comando",
      instance_uuid: "UUID da Instância",
      seq: "Sequência",
      files: "Arquivos",
      comments: "Comentários",
      cmd_id: "ID do Comando",
      cmd_name: "Nome do Comando",
      created_at: "Criado em",
      source_timestamp: "Timestamp de Origem",
      user_info: "Informações do Usuário",
      email: "E-mail",
      command: "Comando",
      information: "Informação",
      full_name: "Nome",
      soeid: "SOEID",
      alarm_workflow: 'Fluxo de Alarma',
      TAKEN: 'O operador assumiu o alarme',
      RELEASED: 'O operador liberou o alarme',
      SENT_TO_REVIEW: 'O operador enviou o alarme para revisão',
      CHANGES_REQUESTED: 'O supervisor solicitou alterações no alarme',
      SUPERVISOR_TAKEN_FROM_POOL: 'O supervisor assumiu o alarme da lista',
      OPERATOR_RESUMED_WORK: 'O operador abriu o alarme',
      COMPLETED: 'O alarme foi marcado como concluído',
    },
    selected_alarms: "Alarmes Selecionados",
    filters: "Filtros",
    type_alarm_categories: "Categorias de tipo de alarme",
    type_alarm_categories_placeholder: "Selecione uma categoria",
    select_options: "Selecionar",
    remove_options: "Desselecionar"
  },
};
